// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Mw-YK","postIdPage":"Header_postIdPage__A9OPd","frame":"Header_frame__lmJPc","title":"Header_title__MvkNC","create_btn":"Header_create_btn__SAEDU"};